import { section } from '@/neon';
import scrollIntoView from '@/lib/scrollIntoView';

const selectors = {
  sliderContainer: '.text-columns__content',
  animatedItems: '.animates',
};

section('text-columns-with-images', {
  animationPlayedOnLoad: false,

  onLoad() {
    this.animatedItems = this.container.querySelectorAll(
      selectors.animatedItems
    );

    this.scrollAnimation = scrollIntoView(this.container, this.animatedItems);
  },

  onUnload() {
    this.scrollAnimation.unload();
  },
});
